import { render, staticRenderFns } from "./dining-preference.vue?vue&type=template&id=1a3c7f1e"
import script from "./dining-preference.vue?vue&type=script&lang=js"
export * from "./dining-preference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/common/i18n/i18n-locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fsean%2Fprojects%2Fezmeals%2Fezmeals-order-ui%2Fsrc%2Fpages%2Fdining-preference.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports